<template>
    <div :style="activeStyle()" class="render-form-item" >
        <span class="search-item-left">{{field.name}}：</span>
        <template v-if="field.type === 'text'">
            <div class="search-item-right"> 
                <el-input v-if="fieldSubType === 'input'" v-model="formField" :placeholder="'请输入'+field.name"/>
                <el-input  v-if="fieldSubType === 'textarea'" type="textarea" :autosize="{ minRows: 2, maxRows: 4}" :placeholder="'请输入'+field.name" v-model="formField" />
            </div>
        </template>
        <template v-if="field.type === 'number'">
            <div class="search-item-right"> 
                <el-input type="number" onkeypress="this.value=this.value.replace(/[^0-9.]/g,'')" :placeholder="'请输入'+field.name" v-model="formField" />
            </div>
        </template>
        <template v-if="field.type === 'date'">
            <div class="search-item-right"> 
                <el-date-picker v-if="fieldSubType === 'date'" type="date" v-model="formField" value-format="yyyy-MM-dd" :editable="true" placeholder="选择日期" style="width: 100%;"></el-date-picker>
                <el-date-picker v-if="fieldSubType === 'dateTime'" type="datetime" v-model="formField" value-format="yyyy-MM-dd HH:mm:ss" :editable="true" placeholder="选择日期" style="width: 100%;"></el-date-picker>
            </div>
        </template>
        <template v-if="field.type === 'category'">
            <div class="search-item-right"> 
                <el-radio-group v-if="fieldSubType === 'single'" v-model="formField">
                    <el-radio v-for="(item, index) in field.options.config.options" :key="index" :label="item.value">{{item.title}}</el-radio>
                </el-radio-group>
                <el-checkbox-group v-if="fieldSubType === 'multi'" v-model="categoryMultiValue">
                    <el-checkbox v-for="(item, index) in field.options.config.options" :key="index" :label="item.value">{{item.title}}</el-checkbox>
                </el-checkbox-group>
            </div>
        </template>
        <template v-if="field.type === 'select'">
            <div class="search-item-right"> 
                <el-select v-model="formField" :key="field.id" clearable filterable :placeholder="'请选择'+field.name">
                    <el-option
                        v-for="(item) in field.options.config.options"
                        :key="item.value"
                        :label="item.title"
                        :value="item.value"
                    />
                </el-select>
            </div>
        </template>
        <template v-if="field.type === 'cascader'">
            <div class="search-item-right"> 
                <el-cascader
                    :ref="field.formField"
                    :options="field.options.config.options"
                    clearable
                    @change="handleCascaderData"
                    :props="{
                        label:'title',
                        expandTrigger: 'hover',
                        multiple: true
                    }"
                >
                </el-cascader>
            </div>
        </template>
        <template v-if="field.type === 'dictionary'">
            <div class="search-item-right"> 
                <DictionaryTree
                    ref="treeChild"
                    :rootId="treeRoot.id"
                    :popover="true"
                    @nodeClick="handleTreeNode"
                />
            </div>
        </template>
        <template v-if="field.type === 'businessTree'">
            <div class="search-item-right"> 
                <BusinessTree
                    ref="treeChild"
                    :rootId="treeRoot.id"
                    :popover="true"
                    @nodeClick="handleTreeNode"
                />
            </div>
        </template>
        <template v-if="field.type === 'user'">
            <div class="search-item-right"> 
                <User :field="field" ref="userChild" :key="field.id" :formData="formData"  @nodeClick="handleTreeNode"/>
            </div>
        </template>
        <template v-if="field.type === 'department'">
            <div class="search-item-right"> 
                <Department
                    ref="treeChild"
                    :key="field.id"
                    :rootId="treeRoot.id"
                    :popover="true"
                    @nodeClick="handleTreeNode"
                />
            </div>
        </template>
        <template v-if="field.type === 'serialNumber' || field.type === 'file' || field.type === 'link'">
            <div class="search-item-right"> 
                <el-input maxlength="100" v-model.trim="formField" :placeholder="'请输入'+field.name"></el-input>
            </div>
        </template>
        <template v-if="field.type === 'process'">
            <div class="search-item-right"> 
                <el-tooltip :disabled="!selectedProcess.selectedProcessNames" :content="selectedProcess.selectedProcessNames" effect="light" placement="top">
                    <el-input :readonly="true"  v-model="selectedProcess.selectedProcessNames" @focus="chooseProcess" ></el-input>
                </el-tooltip>
                <ProcessSelectPop  :field="field" :selectedProcess="selectedProcess" :isShowProcessPop='isShowProcessPop' ref="processPop" :formData="formData"  @nodeClick="processSelectedClick"/>
            </div>
        </template>
    </div>
</template>

<script>
    export default {
        components: {
        },
        data () {
            return {
                selectedProcess: {
                    selectedProcessIds: '',
                    selectedProcessNames: ''
                },
                isShowProcessPop: false,
                treeData: [],
                numberObj: {}
                // popoverTreeLabel:''
            };
        },
        props: {
            field: {
                type: Object,
                required: true
            },
            formData: {
                type: Object,
                required: true
            },
            colSpan: {
                type: Number
            }
        },
        created () {
            // this.formData[formField] = getNewSerialNumber(this.field.options.config.options[0].value);
            // this._setDefault();
            // console.log(this.formData);
            this._initProps();
            //  this._setProps();
            //  console.log("init");
        },
        computed: {
            formField: {
                set (newVal, oldVal) {
                    this.$set(this.formData, this.field.formField, newVal);
                    this.field.conditionValue = newVal;
                    if (this.field.type === 'category' || this.field.type === 'select') {
                        let obj = {};
                        obj = this.field.options.config.options.find((item) => {
                            return item.value === newVal;
                        });
                        this.formData[this.field.formField + '-view'] = obj.title; // 针对选项、下拉进行名称赋值
                        this.field.conditionValueView = obj.title;
                    }
                },
                get (val) {
                    if (val) {
                        return this.formData[this.field.formField];
                    } else {
                        return '';
                    }
                }
            },
            fieldSubType () {
                return this.field.options.config.type;
            },
            categoryMultiValue: {
                get (val) {
                    let formField = this.field.formField;
                    if (this.formData[formField]) {
                        return this.formData[formField];
                    } else {
                        return [];
                    }
                },
                set (newVal, oldVal) {
                    let formField = this.field.formField;
                    this.formData[formField] = newVal.join(',');
                    this.$set(this.formData, formField, newVal);
                    this.field.conditionValue = newVal;
                    let viewArr = newVal;
                    let viewData = [];
                    for (var i = 0; i < viewArr.length; i++) {
                        // console.log(viewArr[i]);
                        let obj = {};
                        obj = this.field.options.config.options.find((item) => {
                            return item.value === viewArr[i];
                        });
                        if (obj.title) {
                            viewData.push(obj.title);
                        }
                    }
                    if (viewData.length > 0) {
                        this.formData[formField + '-view'] = viewData.join(','); // 针对选项、下拉进行名称赋值(多选)
                        this.field.conditionValueView = viewData.join(',');
                    }
                }
            },
            treeRoot () {
                if (this.field.options.config.type === 'single') {
                    if (this.field.options.config.options[0]) {
                        return {
                            id: (this.field.options.config.options[0].value),
                            label: this.field.options.config.options[0].title
                        };
                    } else {
                        return {};
                    }
                } else {
                    return {};
                }
            }
        },
        methods: {
            handleTreeNode (data, node, tree) {
                this.formData[this.field.formField] = data.id;
                this.formData[this.field.formField + '-tree'] = data.label;
                this.field.conditionValue = data.id;
                this.field.conditionValueView = data.label;
            },
            async _initProps () {
                this.field.formField = this.field.id;
                if (this.field.type === 'dictionary' || this.field.type === 'businessTree' || this.field.type === 'department') { // 数据字典、业务分类
                    let node = {};
                    node.title = this.field.conditionValueView;
                    node.value = this.field.conditionValue;
                    setTimeout(() => { // 默认回显值
                        if (this.$refs.treeChild && this.$refs.treeChild._refreshSelectedNode) {
                            this.$refs.treeChild._refreshSelectedNode(node);
                        }
                    }, 100);
                } else if (this.field.type === 'user') {
                    let selectedUser = {};
                    selectedUser.trueName = this.field.conditionValueView;
                    selectedUser.userId = this.field.conditionValue;
                    setTimeout(() => { // 默认回显值
                        if (this.$refs.userChild) {
                            this.$refs.userChild._setDefaultUser(selectedUser);
                        }
                    }, 0);
                } else if (this.field.type === 'category' || this.field.type === 'select' || this.field.type === 'text' || this.field.type === 'file' || this.field.type === 'serialNumber') {
                    if (this.fieldSubType === 'multi' && this.field.conditionValue) {
                        let multi = this.field.conditionValue;
                        this.$set(this.formData, this.field.formField, multi);
                    } else {
                        this.$set(this.formData, this.field.formField, this.field.conditionValue);
                    }
                } else if (this.field.type === 'process') { // 选择条件，点击查询后再次打开，显示上次的选择值
                    this.selectedProcess.selectedProcessNames = this.field.conditionValueView;
                    this.selectedProcess.selectedProcessIds = this.field.conditionValue;
                } else if (this.field.type === 'link') {
                    this.formField = this.field.conditionValue;
                }
            },
            activeStyle () {
                let single = {
                    'display': 'flex'
                };
                // console.log(this.colSpan);
                return single;
            },
            chooseProcess () {
                setTimeout(() => { // 初始化
                    if (this.$refs.processPop) {
                        this.$refs.processPop._initPage();
                    }
                }, 0);
                this.isShowProcessPop = true;
            },
            processSelectedClick (data) {
                this.field.conditionValue = data.selectedProcessIds;
                this.field.conditionValueView = data.selectedProcessNames;
            },
            handleCascaderData (value) {
                if (value.length > 0) {
                    let viewArray = [];
                    let filtVal = 0;
                    this.$refs[this.field.formField].getCheckedNodes().forEach(node => {
                        if (this.arrayContainFunc(value, node.path)) {
                            viewArray.push(node.pathLabels.join('/'));
                            filtVal = filtVal | node.data.filtVal;
                        }
                    });
                    this.formData[this.field.formField + '-view'] = viewArray.join(',');
                    this.formData[this.field.formField + '-filtVal'] = filtVal;
                    this.field.conditionValue = filtVal;
                    this.field.conditionValueView = viewArray.join(',');
                } else {
                    this.field.conditionValue = '';
                    this.field.conditionValueView = '';
                }
            },
            arrayContainFunc (arr, cur) {
                let result = false;
                arr.map((e, i) => {
                    if (JSON.stringify(e) == JSON.stringify(cur)) result = true;
                });
                return result;
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/SearchCondition/SearchFieldItem.vue